
import axios from "axios";


const url = process.env.REACT_APP_APPROVAL_URL;



export const GetImages = async (imageurl,setIsLoading,handleAlertOpen,handleDialogOpen,setFileType,setFile)=>{
    try {
      setIsLoading(true);
      const res = await axios.post(`${url}/download`, {url:imageurl},{
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('UserToken')}`
        },
        responseType:"arraybuffer"
      });
      setIsLoading(false);
      if (res.status === 200) {
        handleDialogOpen(res.data);
          console.log(res.data);
          const blob = new Blob([res.data], {
            type: res.headers["content-type"],
          });
          const imageUrl = URL.createObjectURL(blob);
          // setImageFile(imageUrl);
          setFile(imageUrl);
          const contentType = res.headers["content-type"];
  
          if (contentType === 'application/pdf') {
            setFileType('pdf')
          } else {
            setFileType('image')
          }
      }
    } catch (error) {
      setIsLoading(false);
      handleAlertOpen(error.response &&  error.response.data.error ? error.response.data.error : 'Something went wrong!!!',"error");
      console.log("error",error);
      
    }
  }